module.exports = __webpack_public_path__ + "img/m2_old.c568e752.png";